<article class="w-full h-full relative overflow-hidden">
  <app-navbar></app-navbar>

  <app-gallery [id]="'main'" [typedMessage]="true"></app-gallery>

  <app-gallery-banner [slug]="'map'" [scrollSectionId]="'newsSection'" [color]="'yellow'"></app-gallery-banner>

  <section class="w-full h-full bg-cover md:bg-contain bg-no-repeat bg-right-bottom xl:bg-right"
    style="background: url('https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2FbgYellow.svg?alt=media&token=f5e51f76-ced8-4e33-abd0-e59f13be7f56');">
    <app-news-gamc [scrollSectionId]="'app-innovaHomeSection'"></app-news-gamc>
  </section>

  <app-information-preview [slug]="'app-innova'" [invert]="true"
    [scrollSectionId]="'panelsHomeSection'">
  </app-information-preview>

  <app-information-preview [slug]="'panels'" [scrollSectionId]="'visita-cochaHome'"></app-information-preview>

  <app-gallery-banner [slug]="'visita-cocha'" [color]="'yellow'"
    [scrollSectionId]="'parkingHomeSection'">
  </app-gallery-banner>

  <app-information-preview [slug]="'parking'" [invert]="true"
    [scrollSectionId]="'environmentHomeSection'">
  </app-information-preview>

  <app-information-preview [slug]="'environment'" [scrollSectionId]="'overpassHomeSection'"></app-information-preview>

  <app-information-preview [slug]="'overpass'" [scrollSectionId]="'innovaHome'"
    [invert]="true">
  </app-information-preview>

  <app-gallery-banner [slug]="'innova'" [color]="'cherry'" [scrollSectionId]="'ledHomeSection'"></app-gallery-banner>

  <app-information-preview [slug]="'led'" [scrollSectionId]="'taxiCheckerHome'"></app-information-preview>

  <!-- <app-information-preview [slug]="'trash'" [invert]="true" [scrollSectionId]="'taxiCheckerHome'"></app-information-preview> -->

  <app-gallery-banner [slug]="'taxiChecker'" [color]="'yellow'" [scrollSectionId]="'bitcoin-bannerHome'"></app-gallery-banner>

  <app-gallery-banner [slug]="'bitcoin-banner'" [color]="'yellow'"></app-gallery-banner>

  <app-footer></app-footer>
  
  <app-local-message></app-local-message>
</article>